import cookie from 'cookie';
import {gladiatorService} from '@jobseeker/common-core/services';
import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
import type {GetServerSidePropsContext} from 'next/types';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export async function getMultiApplyVariant(
  context: GetServerSidePropsContext
): Promise<boolean> {
  if (isAppIimjobs) return true;

  try {
    const cookieHeader = context.req?.headers?.cookie;
    const abCookies = cookieHeader ? cookie.parse(cookieHeader) : {};
    const tDsCookie = abCookies?.['_t_ds'];

    if (!tDsCookie) {
      return true;
    }

    let sessionToken: string | undefined;
    if (abCookies?.[COOKIE_LOGIN_AUTH]) {
      const validateInfo = await gladiatorService.validate('validate', {
        headers: {cookie: cookieHeader},
      });
      sessionToken = validateInfo?.token;
    }

    const abResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AB_TEST}/get-variant?experimentId=2`,
      {
        method: 'GET',
        headers: {
          referer: `https://www.${process.env.NEXT_PUBLIC_APP_DOMAIN}/`,
          ...(sessionToken ? {Authorization: `Bearer ${sessionToken}`} : {}),
          cookie: `_t_ds=${tDsCookie}`,
          _t_ds: tDsCookie,
        },
      }
    );
    const abData = await abResponse.json();
    const variantName = abData?.data?.variant?.name;
    return !!variantName && variantName === 'control';
  } catch (_) {
    return true;
  }
}
